import { createBrowserRouter } from 'react-router-dom';

import HomePage from 'pages/Home';
import OrdersPage from 'pages/Orders';
import ProfilePage from 'pages/Profile';

import LoginPage from 'pages/Login';
import RegisterPage from 'pages/Register';
import ForgotPasswordPage from 'pages/ForgotPassword';

import AdminHomePage from 'pages/Admin/Home';
import AdminPluginPage from 'pages/Admin/Plugin';
import AdminTicketPage from 'pages/Admin/Ticket';
import AdminTicketDetailPage from 'pages/Admin/TicketDetail';

import Error404Page from 'pages/errors/404';
import Error403Page from 'pages/errors/403';

import PublicRoute from './PublicRoute';
import PrivateRoute from './PrivateRoute';

const router = createBrowserRouter([
  {
    path: '/',
    element: <PrivateRoute />,
    children: [
      {
        index: true,
        element: <HomePage />
      },
      {
        path: 'orders',
        element: <OrdersPage />
      },
      {
        path: 'profile',
        element: <ProfilePage />
      },
      {
        path: 'admin',
        element: <PrivateRoute allowedRoles={['admin']} />,
        children: [
          {
            index: true,
            element: <AdminHomePage />
          },
          {
            path: 'tickets',
            element: <AdminTicketPage />
          },
          {
            path: 'tickets/:ticketId',
            element: <AdminTicketDetailPage />
          },
          {
            path: 'plugins',
            element: <AdminPluginPage />
          }
        ]
      }
    ]
  },
  {
    path: '/login',
    element: <PublicRoute element={<LoginPage />} />
  },
  {
    path: '/register',
    element: <PublicRoute element={<RegisterPage />} />
  },
  {
    path: '/forgot-password',
    element: <PublicRoute element={<ForgotPasswordPage />} />
  },
  {
    path: '/403',
    element: <Error403Page />
  },
  {
    path: '*',
    element: <Error404Page />
  }
]);

export default router;
